<template>
  <li>
    <div class="form-check">
      <div class="node-info-container" v-show="is_visible">
        <span class="toggle_children" v-if="must_show_toggler" @click="toggle_children">
          <i class="fas fa-plus" v-if="!show_children"></i>
          <i class="fas fa-minus" v-else-if="show_children"></i>
        </span>
        <input
          type="checkbox"
          class="form-check-input"
          v-bind:value="id"
          :id="id"
          v-model="checked"
          @click="toggle_check"
          ref="checkbox"
          v-if="show_checkbox"
        />
        <label
          :class="class_label_parent"
          :for="id">{{ name }}</label>
        <span v-if="counts_visible" class="badge badge-pill badge-secondary">{{ total }}</span>
      </div>
      <ul class="list-unstyled">
        <transition name="fade" v-for="child in children" :key="`transition_${child.id}`">
          <forms-checkbox-tree-node-vue
            v-show="must_show_children"
            :key="child.id"
            v-bind="child"
            :filter="filter"
            :is_filtering="is_filtering"
            :selected="selected"
            :auto_select_children="auto_select_children"
            :counts_visible="counts_visible"
            :only_selection_visible="only_selection_visible"
            ref="children"
            @update_selected="update_selected"
            @status_changed="child_changed"
            class="font-weight-normal"
            :indeterminate-available="indeterminateAvailable"
          />
        </transition>
      </ul>
    </div>
  </li>
</template>

<script>
  import mixins from 'common/mixins.js'
  export default {
    props: {
      id: { type: String, default: ""},
      name: { type: String, default: ""},
      children: { type: Array, default: () => []},
      total:  { type: Number, default: 0},
      filter: { type: String, default: ""},
      is_filtering: { type: Boolean, default: false },
      selected: { type: Array, default: () => []},
      auto_select_children: { type: Boolean, default: false },
      counts_visible: { type: Boolean, default: true },
      only_selection_visible: { type: Boolean, default: false },
      indeterminateAvailable: { type: Boolean, default: true },
      virtual: { type: Boolean, default: false }
      },
    data: function() {
      return {
        show_children: false,
        checked: this.selected.includes(this.id),
        indeterminate: false
      }
    },
    name: 'forms-checkbox-tree-node-vue',
    mixins: [mixins.regex_utils],
    computed: {
      has_children() {
        return this.children.length > 0
      },
      is_visible() {
        return !(this.is_filtering && !this.is_match || this.only_selection_visible && (!this.checked && !this.indeterminate))
      },
      is_match() {
        return this.name.match(this.text_to_regex(this.filter))
      },
      show_checkbox(){
        return !this.virtual
      },
      must_show_children() {
        return this.show_children || this.is_filtering
      },
      must_show_toggler() {
        return this.has_children && !this.is_filtering && !this.only_selection_visible
      },
      class_label_parent() {
        return this.virtual ? 'form-check-label-parent' : 'form-check-label'
      }
    },
    methods: {
      toggle_check() {
        this.set_checked(!this.checked)
      },
      set_checked(value) {
        if (this.checked != value) {
          this.checked = value
          var ids = []
          this.collect_ids(ids)
          this.check_indeterminate()
          this.$emit('update_selected', ids, value)
          this.$emit('status_changed')
        }
      },
      collect_ids(list) {
        list.push(this.id)
        if (this.auto_select_children) {
          (this.$refs.children || []).forEach(function(child) {
            child.collect_ids(list)
          })
        }
      },
      toggle_children() {
        this.show_children = !this.show_children;
      },
      expand(value, all = true) {
        if (this.has_children) {
          this.show_children = value
          if (all)
            this.$refs.children.forEach((child) => child.expand(value, all))
        }
      },
      check_filtered() {
        if (this.is_match) {
          this.set_checked(true)
        }
        if (this.has_children) {
          this.$refs.children.forEach((child) => child.check_filtered())
        }
      },
      update_selected(ids, checked) {
        if (!this.checked)
          this.check_indeterminate()
        this.$emit('update_selected', ids, checked)
      },
      check_indeterminate() {
        if(!this.virtual){
          this.indeterminate = false
          if (this.indeterminateAvailable && this.has_children && !this.checked) {
            this.indeterminate = this.$refs.children.some((child) => {
              return child.$data.indeterminate || child.$data.checked
            })
          }
        }
      },
      child_changed() {
        this.check_indeterminate()
        this.$emit('status_changed')
      }
    },
    watch: {
      selected(value) {
        var checked = value.includes(this.id)
        if (this.checked != checked) {
          this.checked = checked
          this.check_indeterminate()
          this.$emit('status_changed')
        }
      },
      indeterminate(value) {
        this.$refs.checkbox.indeterminate = value
      }
    },
    mounted(){
      this.check_indeterminate()
    }
  }
</script>
